
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport06Dialog extends Serenity.EntityDialog<IcReport06Row, any> {
        protected getFormKey() { return IcReport06Form.formKey; }
        protected getIdProperty() { return IcReport06Row.idProperty; }
        protected getLocalTextPrefix() { return IcReport06Row.localTextPrefix; }
        protected getNameProperty() { return IcReport06Row.nameProperty; }
        protected getService() { return IcReport06Service.baseUrl; }
        protected getDeletePermission() { return IcReport06Row.deletePermission; }
        protected getInsertPermission() { return IcReport06Row.insertPermission; }
        protected getUpdatePermission() { return IcReport06Row.updatePermission; }

        protected form = new IcReport06Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}